var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnderline = function SvgUnderline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 4C7.75 3.58579 7.41421 3.25 7 3.25C6.58578 3.25 6.25 3.58579 6.25 4L6.25 11C6.25 14.1756 8.82436 16.75 12 16.75C15.1756 16.75 17.75 14.1756 17.75 11L17.75 4C17.75 3.58579 17.4142 3.25 17 3.25C16.5858 3.25 16.25 3.58579 16.25 4L16.25 11C16.25 13.3472 14.3472 15.25 12 15.25C9.65279 15.25 7.75 13.3472 7.75 11L7.75 4ZM6 19.25C5.58578 19.25 5.25 19.5858 5.25 20C5.25 20.4142 5.58578 20.75 6 20.75L18 20.75C18.4142 20.75 18.75 20.4142 18.75 20C18.75 19.5858 18.4142 19.25 18 19.25L6 19.25Z"
  })));
};
export default SvgUnderline;